export default __webpack_public_path__ + "static/media/Dragonfly-Multi-Colored-Swarovski-Earrings.72e4d2eb.jpg";